import { CIVIL_JUDGEMENT } from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/constants';

export const EMPTY_CIVIL_JUDGEMENT = {
  [CIVIL_JUDGEMENT.VICTIM_CIVIL_JUDGEMENT]: false,
  [CIVIL_JUDGEMENT.VEHICLE_CIVIL_JUDGEMENT]: false,
  [CIVIL_JUDGEMENT.CIVIL_JUDGEMENT_VICTIM_RECAP]: false,
  [CIVIL_JUDGEMENT.CIVIL_JUDGEMENT_VEHICLE_RECAP]: false,
  [CIVIL_JUDGEMENT.SUBSTANTIVE_REJECTION_RECAP]: false,
  [CIVIL_JUDGEMENT.FORM_REJECTION_RECAP]: false,
  [CIVIL_JUDGEMENT.SUBSTANTIVE_REJECTION]: false,
  [CIVIL_JUDGEMENT.FORM_REJECTION]: false,
};
export const FEES = {
  FUNERAL_VICTIM_FEES: 'funeralVictimFees',
  FUNERAL_BENEFICIARY_FEES: 'funeralBeneficiaryFees',
  MEDICAL_VICTIM_FEES: 'medicalVictimFees',
  MEDICAL_BENEFICIARY_FEES: 'medicalBeneficiaryFees',
};
